import { useReducedMotion } from "motion/react";
import { ChangeEvent, useEffect, useRef } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import {
  DRAWER_SETTINGS_CONTENT_ENTER_DURATION_S,
  MILLISECONDS_IN_SECOND,
  mobileSettingsSearchAtom,
} from "@ryde/shared";

export const useMobileSettingsSearch = () => {
  const [searchText, setSearchText] = useRecoilState(mobileSettingsSearchAtom);
  const inputRef = useRef<HTMLInputElement>(null);
  const isReducedMotion = useReducedMotion();

  useEffect(() => {
    if (isReducedMotion) {
      inputRef.current?.focus();
      return;
    }

    const focusDelayMs =
      DRAWER_SETTINGS_CONTENT_ENTER_DURATION_S * MILLISECONDS_IN_SECOND;
    const timeoutId = window.setTimeout(() => {
      inputRef.current?.focus();
    }, focusDelayMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isReducedMotion]);

  const onSearchChange = useEvent((event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  });
  const onClearSearch = useEvent(() => {
    setSearchText("");
  });

  return {
    searchText,
    inputRef,
    onSearchChange,
    onClearSearch,
  };
};
